export default new Map();
